import { faPrint } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, AlertDescription, AlertTitle } from '@shared/components/ui/shadcn/alert';
import { useTranslation } from 'react-i18next';

export const AttachmentPrinterRequiredAlert = () => {
  const { t } = useTranslation('packingModule');

  return (
    <Alert className="mb-4 border-info/80 bg-bg-info items-center flex justify-center gap-4">
      <div>
        <FontAwesomeIcon icon={faPrint} className="w-5 h-5 !text-info" />
      </div>
      <div className="flex-1">
        <AlertTitle className="text-info text-base !mb-0">{t('alerts.attachmentPrinterRequired.title')}</AlertTitle>
        <AlertDescription>{t('alerts.attachmentPrinterRequired.message')}</AlertDescription>
      </div>
    </Alert>
  );
};
